<template>
    <el-container class="relative table-page no-shrink-mobile">
        <!--<aside class="filters-bar el-aside d-flex column sidebar-links">-->
        <!--</aside>-->
        <div class="container1300">
            <div class="el-main" v-loading="isLoading">
            <h1 class="flex-center" style="font-size: 50px; margin-bottom: 0px; line-height: 1; text-align: left"><img src="/static/cooboicon1.svg" alt="" style="margin: 0 20px 0 0; width: 80px"><span>ANALYTICS REPORT</span></h1>
            <div class="flex-center">
              <p style="font-size: 20px;margin-bottom:50px;">The most powerful learning experiences will have clear attribution between their consumption and actual learning outcomes. Engagement is not a proxy for effective content in education. The Embibe Coobo LEs will set a new benchmark in continuously evolving, data driven content creation for the new era. The feedback from consumption will be used to create adaptive LEs as well as evolve the creative direction behind teaching. The tagging framework and tech will lend itself easily to traditional problems in scaling media like internationalisation. Embibe Coobo will together measure millions of parameters on learning experiences. This will supercede what youtube does as well as create a new taxonomy of tags specific to education catering to learning styles and more.</p>
            </div>

            <div v-if="Object.keys(info).length" class="a-block info-block">
                <h2 class="title"><img src="/static/cooboicon2.svg" alt="">General info</h2>
                <div class="data">
                    <div v-for=" (item, itemName) in info" class="value">
                            <span class="key">{{itemName}}:</span>
                            <span class="val"  v-if="typeof item !== 'object'" >{{item}}</span>
                            <span class="val d-flex flex-wrap"  v-else>
                            <span v-for="(objVal, objKey) in item" class="d-flex" style="padding: 0 5px">
                                <b style="margin-right: 3px">{{objKey}}: </b> <span> {{objVal}}</span>
                            </span>
                            </span>
                    </div>
                </div>
            </div>
            <div v-if="chartData.labels.length" class="a-block chart-block">
                <h2 class="title"><img src="/static/cooboicon3.svg" alt="">USER ACTIVITY</h2>
                <div class="data">
                    <div style="padding: 40px 20px 40px 10px; background: rgba(255,255,255,0.9)">
                        <bar-chart :chartdata="chartData"/>
                    </div>
                </div>
                <div class="data">
                    <el-table
                        :data="actions"
                        border
                        :span-method="objectSpanMethod"
                        :cell-style="cellStyle"
                        style="width: 100%">
                        <el-table-column
                            prop="slide"
                            label="Slide"
                            width="150px">
                            <template slot-scope="scope">
                                <span>{{ "Slide " + (scope.row.slide + 1) }} <em v-if="scope.row.slideTime">({{formatTime(scope.row.slideTime, true)}})</em></span>
                                <img src="/static/rewind.svg" v-if="scope.row.rewind" class="rewind-icon"
                                     title="Rewind"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="timestamp"
                            label="Time"
                            width="80px">
                            <template slot-scope="scope">
                                <span>{{formatTime(scope.row.timestamp)}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="text"
                            label="Action"/>
                    </el-table>
                </div>
            </div>
            <div class="a-block results-block" v-if="result">
                <h2 class="title"><img src="/static/cooboicon4.svg" alt="">Learning outcome</h2>
                <div class="data">
                    <results-table :label-quiz="labelQuiz" :slide-quiz="slideQuiz" :result="result"/>
                    <h4 style="margin: 10px 0 "><span style="margin-right: 5px;">TOTAL SCORE:</span> {{result.score}}</h4>
                    <h4 style="margin: 10px 0 "><span style="margin-right: 5px;">TIME SPENT:</span> {{formatTime(Math.round(result.time/1000), true)}}</h4>
                </div>
            </div>
        </div>
        </div>
    </el-container>
</template>

<script>
  import BarChart from "../components/bar-chart.vue"
  import ResultsTable from "../components/results-table.vue"

  export default {
    name: 'Analytics',
    components: {BarChart, ResultsTable},
    data() {
      return {
        isLoading: true,
        dataId: '',
        info: {},
        stack: [],
        tourStarted: null,
        actions: [],
        result: null,
        labelQuiz: [],
        slideQuiz: [],
        chartData: {
          labels: [],
          datasets: [
            {
              label: 'Slide Time',
              backgroundColor: 'rgba(35,136,248, 0.5)',
              borderColor: 'rgb(35,136,248)',
              borderWidth: '1',
              data: []
            },
            {
              label: 'Quiz time',
              backgroundColor: 'rgba(248,121,121, 0.5)',
              borderColor: '#f84444',
              borderWidth: '1',
              data: []
            },
          ]
        },
      }
    },
    mounted: function () {
      this.axios({
        url: this.$store.state.s3Url + '/analytics/' + this.$route.params.id + ".json",
        method: 'GET',
        headers: {Authorization: ""},
      }).then((res) => {
          this.isLoading = false;
          this.info = res.data.info;
          this.info["Framerate"] = Math.round(this.info["Framerate"].reduce((s, a) => s + a)/this.info["Framerate"].length);
          this.info["Screen Size"] = this.info["Screen Size"].width + "x" + this.info["Screen Size"].height
          this.stack = res.data.stack;
          this.tourStarted = res.data.stack[0].entered;
          let prev = 0;
          this.stack.forEach((s, i) => {
            let label = "Slide " + (s.slide + 1);

            let slideTime = Math.ceil((s.leaved - s.entered) / 1000);
            let quizTime = s.quizSubmitted ? (Math.ceil((s.quizSubmitted - s.entered) / 1000)) : 0;
            this.chartData.datasets[0].data.push(slideTime);
            this.chartData.datasets[1].data.push(quizTime);
            s.actions[0].slide = s.slide;
            s.actions[0].slideTime = slideTime;
            s.actions[0].span = s.actions.length;
            if (prev > s.slide) {
              s.actions[0].rewind = true;
              label += " ↶"
            }
            this.chartData.labels.push(label);
            this.actions.push(...s.actions);
            prev = s.slide;
          });

          this.result = res.data.results;
          this.labelQuiz = Object.values(JSON.parse(this.result.labelQuiz)).filter((q) => {
            return q.active
          });
          this.slideQuiz = JSON.parse(this.result.slideQuiz).filter(q => (q && q.active));

        });
    },
    methods: {
      formatTime(time, isSeconds) {
        let sec = isSeconds ? time : Math.round((time - this.tourStarted) / 1000);
        let hh = Math.floor(sec / 3600);
        let mm = Math.floor((sec - (hh * 3600)) / 60);
        let ss = sec - (hh * 3600) - (mm * 60);
        if (hh === 0) {
          hh = "";
        } else {
          if (hh < 10) {
            hh = "0" + hh;
          }
          hh = hh + ":";
        }
        if (mm < 10) {
          mm = "0" + mm;
        }
        mm = mm + ":";
        if (ss < 10) {
          ss = "0" + ss;
        }
        return hh + mm + ss;
      },
      cellStyle({row, column, rowIndex, columnIndex}) {
        if (columnIndex === 0 && !row.slide && row.slide !== 0) {
          return {display: "none"}
        }
      },
      objectSpanMethod({row, column, rowIndex, columnIndex}) {
        if (row.span && columnIndex === 0) {
          return {
            rowspan: row.span,
            colspan: 1
          };
        } else {
          return {
            rowspan: 1,
            colspan: 1
          };
        }
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/pages/Analytics.vue